import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { jwtDecode, JwtPayload } from 'jwt-decode';

@Injectable({
    providedIn: 'root'
})

export class TokenService {

    token: any;
    private tokenSubject = new BehaviorSubject<any>(null);
    tokenSubject$: Observable<any> = this.tokenSubject.asObservable();

    constructor(
    ) {
        this.getToken();
    }

    async getToken() {
        console.log(this.token, "TOKEN");
    }

    set accessToken(value: string) {
        this.token = value;
    }

    isTokenExpiringSoon(minutes = 10) {
        const expiry = this.getTokenExpiry();
        if (!expiry) return false;

        const now = Math.floor(Date.now() / 1000);
        return expiry - now <= minutes * 60;
    }

    getTokenExpiry() {
        if (!this.token) return null;

        try {
            const decoded = jwtDecode<JwtPayload>(this.token?.accessToken);
            return decoded.exp;
        } catch (error) {
            return null;
        }
    }

    isTokenAvailable() {
        return !!this.tokenSubject.value;
    }
}